/* eslint-disable */
import settings from "../../../configs/settings";
import { v4 as uuidv4 } from "uuid";
import {
  Button,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Box } from "@mui/system";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import SearchIcon from "@mui/icons-material/Search";
import SavedSearchIcon from "@mui/icons-material/SavedSearch";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { useContext, useState } from "react";
import GestionAtencionContext from "../../../project/contexts/GestionAtencionContext";
import BuscarFornituraDialog from "./BuscarFornituraDialog";
import { getFornitura } from "../../../project/services/FornituraService";
import Message from "../../../project/utils/Message";
import { formatMoney } from "../../utils/utils"
import { limpiaCodigo } from "../../utils/utils";
import WaitingDialog from "../../utils/WaitingDialog";

//
// ################################################################################
//
const ArregloFornituras = () => {
  const [openDialogBusquedaAvanzada, setOpenDialogBusquedaAvanzada] = useState(false);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [disabledFornituras, setDisabledFornituras] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const {
    initialArregloFornitura,
    arregloFornitura,
    handleChangeArregloFornitura,
    setArregloFornitura,
    arregloForniturasRows,
    setArregloForniturasRows,
    totalArregloFornituras,
    totalArregloForniturasContado,
    gaAction,
  } = useContext(GestionAtencionContext);
  let {
    arregloFornituraCodigo,
    arregloFornituraDescripcion,
    arregloFornituraPrecioVenta,
    arregloFornituraPrecioVentaContado,
    arregloFornituraCantidad,
    arregloFornituraSubtotal,
    arregloFornituraSubtotalContado,
  } = arregloFornitura;

  const tableColumns = [
    {
      field: "arregloFornituraCodigo",
      headerName: "Código",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.arregloFornituraCodigo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "arregloFornituraDescripcion",
      headerName: "Fornitura",
      headerAlign: "center",
      align: "left",
      flex: 4,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.arregloFornituraDescripcion;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "arregloFornituraPrecioVenta",
      headerName: "Prc Lista",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.arregloFornituraPrecioVenta;
        _val = _val ? _val : 0;
        return _val.toFixed(2);
      },
    },
    {
      field: "arregloFornituraPrecioVentaContado",
      headerName: "Prc Contado",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.arregloFornituraPrecioVentaContado;
        _val = _val ? _val : 0;
        return _val.toFixed(2);
      },
    },
    {
      field: "arregloFornituraCantidad",
      headerName: "Cant",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.arregloFornituraCantidad;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "arregloFornituraSubtotal",
      headerName: "Sub Lista",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.arregloFornituraSubtotal;
        _val = _val ? _val : 0;
        return _val.toFixed(2);
      },
    },
    {
      field: "arregloFornituraSubtotalContado",
      headerName: "Sub Contado",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.arregloFornituraSubtotalContado;
        _val = _val ? _val : 0;
        return _val.toFixed(2);
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          {gaAction.cu !== "view" && (
            <Tooltip title="quitar servicio">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => handleClickActionFornitura(params.row)}
              >
                <RemoveCircleOutlineIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  const tableOptions = {
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  const handleClickActionFornitura = (parRow) => {
    if (parRow === undefined) {
      // si estoy agregando un fornitura

      if (arregloFornituraCodigo === "" || arregloFornituraDescripcion === "") {
        setMessage({
          messageText: "Debes seleccionar un fornitura",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }

      let _fornitura = {
        id: uuidv4(),
        arregloFornituraId: arregloFornitura.arregloFornituraId,
        arregloFornituraCodigo: arregloFornitura.arregloFornituraCodigo,
        arregloFornituraDescripcion: arregloFornitura.arregloFornituraDescripcion,
        arregloFornituraPrecioVenta: arregloFornitura.arregloFornituraPrecioVenta,
        arregloFornituraPrecioVentaOriginal: arregloFornitura.arregloFornituraPrecioVentaOriginal,
        arregloFornituraPorcentajeDescuento: arregloFornitura.arregloFornituraPorcentajeDescuento,
        arregloFornituraPrecioVentaContado: arregloFornitura.arregloFornituraPrecioVentaContado,
        arregloFornituraCantidad: arregloFornitura.arregloFornituraCantidad,
        arregloFornituraSubtotal: arregloFornitura.arregloFornituraSubtotal,
        arregloFornituraSubtotalContado: arregloFornitura.arregloFornituraSubtotalContado,
      };
      setArregloForniturasRows([...arregloForniturasRows, _fornitura]);
      setArregloFornitura(initialArregloFornitura);
    } else {
      // si estoy eliminando un fornitura

      let _ForniturasRows = arregloForniturasRows.filter(
        (item) => item.id !== parRow.id
      );
      setArregloForniturasRows(_ForniturasRows);
    }
  };
  //
  // ################################################################################
  //
  const handleBuscarFornitura = () => {
    if (arregloFornituraCodigo === "") {
      return;
    }

    const buscarFornitura = async () => {

      const _arregloFornituraCodigo = limpiaCodigo(arregloFornituraCodigo).toUpperCase();

      setArregloFornitura({
        ...arregloFornitura,
        arregloFornituraCodigo: _arregloFornituraCodigo,
      });

      setIsDoingSomething(true);
      const response = await getFornitura(_arregloFornituraCodigo);
      setIsDoingSomething(false);

      if (response.ok) {
        let _fornitura = {
          arregloFornituraId: response.data.data[0].id,
          arregloFornituraCodigo: response.data.data[0].codigo,
          arregloFornituraDescripcion: response.data.data[0].descripcion,
          arregloFornituraPrecioVenta: response.data.data[0].precio_venta_lista,
          arregloFornituraPrecioVentaOriginal: response.data.data[0].precio_venta_lista,
          arregloFornituraPorcentajeDescuento: 0,
          arregloFornituraPrecioVentaContado: response.data.data[0].precio_venta_lista,
          arregloFornituraCantidad: 1,
          arregloFornituraSubtotal: response.data.data[0].precio_venta_lista,
          arregloFornituraSubtotalContado: response.data.data[0].precio_venta_lista,
        };
        setArregloFornitura(_fornitura);
      } else {
        setMessage({
          messageText: response.messageText,
          severity: response.messageSeverity,
        });
        setShowMessage(true);
        setArregloFornitura(initialArregloFornitura);
      }
    };

    buscarFornitura();
  };
  //
  // ################################################################################
  //
  const handleClickOpenBusquedaAvanzada = () => {
    setOpenDialogBusquedaAvanzada(true);
  };
  //
  // ################################################################################
  //
  const handleCloseBusquedaAvanzada = () => {
    setOpenDialogBusquedaAvanzada(false);
  };
  //
  // ################################################################################
  //
  const handleSelectBusquedaAvanzada = (articulo) => {
    setOpenDialogBusquedaAvanzada(false);

    let _fornitura = {
      arregloFornituraId: articulo.id,
      arregloFornituraCodigo: articulo.codigo,
      arregloFornituraDescripcion: articulo.descripcion,
      arregloFornituraPrecioVenta: articulo.precio_venta_lista,
      arregloFornituraPrecioVentaOriginal: articulo.precio_venta_lista,
      arregloFornituraPorcentajeDescuento: 0,
      arregloFornituraPrecioVentaContado: articulo.precio_venta_lista,
      arregloFornituraCantidad: 1,
      arregloFornituraSubtotal: articulo.precio_venta_lista,
      arregloFornituraSubtotalContado: articulo.precio_venta_lista,
    };
    setArregloFornitura(_fornitura);
  };
  //
  // ################################################################################
  //
  const handleLimpiarFornitura = () => {
    setArregloFornitura(initialArregloFornitura);
  };
  //
  // ################################################################################
  //
  const handleBlur = (e) => {
    let _cantidad = e.target.value;
    _cantidad =
      _cantidad === "" || isNaN(_cantidad) || parseInt(+_cantidad) <= 0 ? 1 : parseInt(+_cantidad);
    let _subtotal = _cantidad * arregloFornituraPrecioVenta;
    let _subtotalContado = _cantidad * arregloFornituraPrecioVentaContado;
    setArregloFornitura({
      ...arregloFornitura,
      arregloFornituraCantidad: _cantidad,
      arregloFornituraSubtotal: _subtotal,
      arregloFornituraSubtotalContado: _subtotalContado,
    });
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Box sx={{ mx: 1, px: 1, pb: 1 }}>
        {gaAction.cu !== "view" && (
          <>
            <Box>
              <Grid container spacing={1}>
                <Grid item md={6}>
                  {/* codigo de fornitura */}

                  <TextField
                    sx={{ mb: 1 }}
                    id="codigo-fornitura"
                    label="Código de Fornitura"
                    variant="outlined"
                    size="small"
                    name="arregloFornituraCodigo"
                    value={arregloFornituraCodigo}
                    onChange={handleChangeArregloFornitura}
                    disabled={arregloFornituraDescripcion !== "" || disabledFornituras}
                  />
                </Grid>

                <Grid item md={6}>
                  {/* boton buscar */}

                  <Button
                    sx={{ mr: 1 }}
                    variant="contained"
                    onClick={handleBuscarFornitura}
                    startIcon={<SearchIcon />}
                    disabled={arregloFornituraCodigo === "" || arregloFornituraDescripcion !== ""}
                  >
                    Buscar
                  </Button>

                  {/* boton busqueda avanzada */}

                  <Button
                    sx={{ mr: 1 }}
                    variant="contained"
                    onClick={handleClickOpenBusquedaAvanzada}
                    startIcon={<SavedSearchIcon />}
                    disabled={disabledFornituras}
                  >
                    Búsqueda Avanzada
                  </Button>

                  {/* boton limpiar */}

                  <Button
                    sx={{ mr: 1 }}
                    variant="outlined"
                    onClick={handleLimpiarFornitura}
                    startIcon={<CleaningServicesIcon />}
                    disabled={arregloFornituraCodigo === ""}
                  >
                    Limpiar
                  </Button>
                </Grid>
              </Grid>

              <Grid container spacing={1}>
                <Grid item xs={12} md={6} sx={{ mb: 1 }}>
                  {/* descripcion */}

                  <TextField
                    sx={{ width: "100%" }}
                    id="arregloFornituraDescripcion"
                    label="Descripción"
                    variant="outlined"
                    size="small"
                    name="arregloFornituraDescripcion"
                    value={arregloFornituraDescripcion}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} md={2} sx={{ mb: 1 }}>
                  {/* precio de lista */}

                  <TextField
                    sx={{ width: "70%" }}
                    inputProps={{ style: { textAlign: "right" } }}
                    id="arregloFornituraoPrecioVenta"
                    label="Precio de lista"
                    variant="outlined"
                    size="small"
                    name="arregloFornituraoPrecioVenta"
                    value={arregloFornituraPrecioVenta.toLocaleString(
                      settings.numericLocales.language,
                      settings.numericLocales.options
                    )}
                    disabled={true}
                  />
                </Grid>

                <Grid item xs={12} md={2} sx={{ mb: 1 }}>
                  {/* precio de contado */}

                  <TextField
                    sx={{ width: "70%" }}
                    inputProps={{ style: { textAlign: "right" } }}
                    id="arregloFornituraPrecioVentaContado"
                    label="Precio de contado"
                    variant="outlined"
                    size="small"
                    name="arregloFornituraPrecioVentaContado"
                    value={arregloFornituraPrecioVentaContado.toLocaleString(
                      settings.numericLocales.language,
                      settings.numericLocales.options
                    )}
                    disabled={true}
                  />
                </Grid>

                <Grid item xs={12} md={2} sx={{ mb: 1 }}>
                  {/* cantidad */}

                  <TextField
                    sx={{ width: "40%" }}
                    inputProps={{ style: { textAlign: "center" } }}
                    id="arregloFornituraCantidad"
                    label="Cantidad"
                    variant="outlined"
                    size="small"
                    name="arregloFornituraCantidad"
                    value={arregloFornituraCantidad}
                    onChange={handleChangeArregloFornitura}
                    onBlur={handleBlur}
                    disabled={arregloFornituraCodigo === ""}
                  />
                </Grid>

                <Grid item xs={12} md={2} sx={{ mb: 1 }}>
                  {/* subtotal de lista */}

                  <TextField
                    sx={{ width: "70%" }}
                    inputProps={{ style: { textAlign: "right" } }}
                    id="arregloFornituraSubtotal"
                    label="Sub Lista"
                    variant="outlined"
                    size="small"
                    name="arregloFornituraSubtotal"
                    value={arregloFornituraSubtotal.toLocaleString(
                      settings.numericLocales.language,
                      settings.numericLocales.options
                    )}
                    disabled={true}
                  />
                </Grid>

                <Grid item xs={12} md={2} sx={{ mb: 1 }}>
                  {/* subotal de contado */}

                  <TextField
                    sx={{ width: "70%" }}
                    inputProps={{ style: { textAlign: "right" } }}
                    id="arregloFornituraSubtotalContado"
                    label="Sub Contado"
                    variant="outlined"
                    size="small"
                    name="arregloFornituraSubtotalContado"
                    value={arregloFornituraSubtotalContado.toLocaleString(
                      settings.numericLocales.language,
                      settings.numericLocales.options
                    )}
                    disabled={true}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2}>
                <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                  {/* boton agregar */}

                  <Button
                    sx={{ mr: 1 }}
                    variant="contained"
                    disabled={
                      disabledFornituras ||
                      arregloFornituraCodigo === "" ||
                      arregloFornituraDescripcion === ""
                    }
                    onClick={() => handleClickActionFornitura()}
                    startIcon={<AddCircleOutlineOutlinedIcon />}
                  >
                    Agregar
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </>
        )}

        <Grid container spacing={2}>
          <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
            <DataGrid
              rows={arregloForniturasRows}
              columns={tableColumns}
              {...tableOptions}
            />
          </Grid>

          <Grid item sm={6}>
            <Typography
              component="div"
              align="right"
              sx={{
                p: 1,
                mt: 2,
                backgroundColor: "LightBlue",
                borderRadius: "5px",
                fontWeight: "bold",
              }}
            >
              PRECIO DE LISTA: {formatMoney(totalArregloFornituras)}
            </Typography>
          </Grid>
          <Grid item sm={6}>
            <Typography
              component="div"
              align="right"
              sx={{
                p: 1,
                mt: 2,
                backgroundColor: "LightBlue",
                borderRadius: "5px",
                fontWeight: "bold",
              }}
            >
              PRECIO DE CONTADO: {formatMoney(totalArregloForniturasContado)}
            </Typography>
          </Grid>
        </Grid>
      </Box>

      {openDialogBusquedaAvanzada && (
        <BuscarFornituraDialog
          open={openDialogBusquedaAvanzada}
          onClose={handleCloseBusquedaAvanzada}
          onSelect={handleSelectBusquedaAvanzada}
        />
      )}

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default ArregloFornituras;
